import { useEffect, useState } from "react";
import { Flex, Box } from "theme-ui";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import { CarouselProps } from "./Carousel.d";

export const Carousel: React.FC<CarouselProps> = ({
  data = [],
  spaceBetween = 20,
  sizes = ["360px", "980px", "100%"],
  renderItem,
}) => {
  const carouselElements = (index: number) => {
    switch (index) {
      case 0:
        return { width: sizes[0], elements: 2, hasGhost: true };
      case 1:
        return { width: sizes[1], elements: 3, hasGhost: true };
      case 2:
        return { width: sizes[2], elements: 4, hasGhost: false };

      default:
        return { width: "100%", elements: 4, hasGhost: false };
    }
  };

  const breakPointIndex = useBreakpointIndex();
  const { elements, width, hasGhost } = carouselElements(breakPointIndex);
  const [activeSlide, setActiveSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const computedData = hasGhost ? [...data, {}] : data;

  // to fix a issue with Swiper and suspense
  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 100);
  }, []);

  if (!isVisible) return null;

  return (
    <>
      <Box sx={{ maxWidth: "100%", overflow: "hidden" }}>
        <Box sx={{ width, p: 1 }}>
          <Swiper
            spaceBetween={spaceBetween}
            slidesPerView={elements}
            onSlideChange={(data) => setActiveSlide(data.activeIndex)}
          >
            {computedData.map((item, index) => {
              const needGhostElement =
                index === computedData.length - 1 && hasGhost;
              return (
                <SwiperSlide key={index}>
                  {needGhostElement ? <></> : renderItem(item, index)}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>
      </Box>
      {hasGhost && (
        <Flex sx={{ gap: "10px", justifyContent: "center", mb: 4 }}>
          {data.map((_, index) => {
            return (
              <Box
                key={index}
                sx={{
                  size: "6px",
                  bg: activeSlide === index ? "accent" : "greyMedium",
                  borderRadius: "50%",
                }}
              />
            );
          })}
        </Flex>
      )}
    </>
  );
};
